import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RequiredAsteriskDirective } from './required-asterisk.directive';



@NgModule({
  declarations: [RequiredAsteriskDirective],
  imports: [
    CommonModule,
  ],
  exports: [RequiredAsteriskDirective]
})
export class RequiredAsteriskModule { }
